import styles from './FJStepHeader.module.less';
import FJLocalStore from '../../../store/FJLocalStore';
import FJBackArrowIcon from '../../../assets/svg/textToVideo/back-arrow.svg?react';
import FJHeaderLineIcon from '../../../assets/svg/textToVideo/header-line.svg?react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Fragment } from 'react';
const FJStepHeader = props => {
    const { onChangeStep, curStep, stepList, gotoBack, className } = props;
    const curIdx = stepList.findIndex(item => item.type === curStep);
    return (
        <div className={classNames(styles.container, className)}>
            <div className={styles.left} onClick={gotoBack}>
                <FJBackArrowIcon />
                <span className={styles.left_title}>{FJLocalStore._('back')}</span>
            </div>

            <div className={styles.center}>
                {stepList.map((item, index) => (
                    <Fragment key={index}>
                        {index !== 0 && <FJHeaderLineIcon className={styles.dotted_line} />}

                        <div
                            className={classNames(
                                styles.center_item,
                                item.type === curStep && styles.active,
                                index > curIdx && styles.disable,
                            )}
                            onClick={() => onChangeStep(item.type)}
                        >
                            <div className={classNames(styles.number, item.type === curStep && styles.active)}>
                                <span className={styles.number_inner_text}>{index + 1}</span>
                                <div className={styles.number_inner}></div>
                            </div>

                            <div className={classNames(styles.center_title)}>{FJLocalStore._(item.name)}</div>
                        </div>
                    </Fragment>
                ))}
            </div>
            <div className={styles.right} />
        </div>
    );
};

FJStepHeader.propTypes = {
    onChangeStep: PropTypes.func,
    curStep: PropTypes.string,
    stepList: PropTypes.array,
    gotoBack: PropTypes.func,
    className: PropTypes.string,
};
export default FJStepHeader;
